/** @jsxImportSource @emotion/react */
import { TableRowHeader } from "../../../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../../../components/table-components/TableCellHeaderText";
import { firstTableCellStyle } from "../../../../style-util";

export const AppHomepageListHeader = () => {
  return (
    <thead>
      <TableRowHeader>
        <TableCellHeaderText css={firstTableCellStyle}>
          Image
        </TableCellHeaderText>
        <TableCellHeaderText>Name</TableCellHeaderText>
        <TableCellHeaderText>Visible?</TableCellHeaderText>
        <TableCellHeaderText>Visible from</TableCellHeaderText>
        <TableCellHeaderText>Visible to</TableCellHeaderText>
        <TableCellHeaderText>News</TableCellHeaderText>
        <TableCellHeaderText>Offers</TableCellHeaderText>
      </TableRowHeader>
    </thead>
  );
};
